import { useState } from "react";
import { Accordion } from "../../components/accordion";
import { Layout } from "../../components/layout";
import { buzzFaqs, loanFaqs } from "../../constants";

const generalFaqs = [
  {
    question: "How safe is MyCardGlobal?",
    answer:
      "MyCardGlobal is designed with security and customer protection in mind. We do not hold customer funds. Payments are processed through Paystack, while savings funds are held by Paystack MFB, a licensed financial institution. MyCard uses secure integrations and industry-standard security practices to protect customer information and transactions.",
  },
  {
    question: "What does MyCardGlobal do?",
    answer:
      "MyCardGlobal is a digital fintech platform that helps you save, access credit and manage your money smarter. Our products include Autosave, Flexisave, Vault, Loans and Buzz, giving customers convenient tools to build better financial habits and achieve their financial goals.",
  },
  {
    question: "Where can I get the MyCardGlobal app?",
    answer:
      "You can download the MyCardGlobal app from the Google Play Store or Apple App Store, subject to availability. You can also visit mycardglobal.com for more information and download options.",
  },
  {
    question: "Will there be a maintenance fee for a MyCardGlobal card?",
    answer:
      "There is currently no maintenance fee for the MyCard card. Any applicable charges or fees will always be clearly communicated to customers before they use a chargeable service.",
  },
];

const faqs = [...generalFaqs, ...loanFaqs, ...buzzFaqs];

export const FaqPage = () => {
  const [openAccordion, setOpenAccordion] = useState();

  return (
    <Layout>
      <section className="bg-grey-bg">
        <div className="max-width py-[56px] lg:py-[80px]">
          <div className="flex max-w-[1091px] flex-col gap-4 lg:gap-6">
            <p className="text-sm font-bold text-grey-500 lg:text-[32px]">
              FAQs
            </p>
            <h1 className="text-[32px] font-bold leading-tight text-deep-primary lg:text-[64px]">
              Have some questions{" "}
              <span className="font-medium italic text-primary">
                About MyCard Global?
              </span>
            </h1>
            <p className="max-w-[744px] text-base font-medium text-grey-500 lg:text-[32px] leading-[100%]">
              Find answers to the most common questions about using
              MyCardGlobal.
            </p>
          </div>
        </div>
      </section>

      <section className="max-width flex flex-col gap-8 py-[56px] lg:items-center lg:gap-[88px] lg:py-[80px]">
        <div className="flex max-w-[604px] flex-col gap-4 lg:items-center">
          <h2 className="text-lg font-bold text-deep-primary lg:text-[32px]">
            Everything you need to know
          </h2>
          <p className="text-sm font-medium leading-5 text-grey-500 lg:text-center lg:text-lg lg:leading-7">
            Explore answers to common questions about your account, savings,
            cards, and other MyCardGlobal services.
          </p>
        </div>

        <div className="flex w-full max-w-[733px] flex-col gap-4">
          {faqs.map((faq, index) => (
            <Accordion
              key={faq.question}
              mainText={faq.question}
              subText={faq.answer}
              isOpen={openAccordion === index}
              onOpen={() =>
                setOpenAccordion(openAccordion === index ? undefined : index)
              }
            />
          ))}
        </div>
      </section>
    </Layout>
  );
};
